import { cn } from "@utils"

const FormError = ({ errors, name, error, className }) => {
  return error
    ? <div className={cn("absolute top-[105%] text-red-500 text-sm", className)}>{error}</div>
    : errors && errors[name] && <div className={cn("absolute top-[105%] text-red-500 text-sm", className)}>{errors[name].message}</div>;
};

export default FormError;

